import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    t: "1686291840812",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "2460",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "200",
    height: "200"
};
export function render(_ctx, _cache) {
    return _openBlock(), _createElementBlock("svg", _hoisted_1, [
        ..._cache[0] || (_cache[0] = [
            _createElementVNode("path", {
                d: "M566.95 110.48v785.91h376.07V110.48H566.95z m-500.13 2.83v786.37h369.19V113.31H66.82z",
                "p-id": "2461"
            }, null, -1)
        ])
    ]);
}
